import { useCallback } from 'react'

import { ConfirmationModal } from 'govwell-ui'

import { useDismissAIChatbotFAQMutation } from 'src/fetch/aiChatbotFAQ'
import { RefetchFnType } from 'src/types'

type Props = {
  id: number
  onClose: () => void
  refetch: RefetchFnType
}
const DismissQuestionModal = ({ id, onClose, refetch }: Props) => {
  const { mutateAsync: dismissAIChatbotFAQ } = useDismissAIChatbotFAQMutation()
  const handleDismiss = useCallback(async () => {
    await dismissAIChatbotFAQ({ id })
    await refetch()
  }, [dismissAIChatbotFAQ, id, refetch])
  return (
    <ConfirmationModal
      cancelText="Cancel"
      confirmText="Dismiss question"
      isDestructive
      onCancel={onClose}
      onConfirm={handleDismiss}
    >
      Are you sure you want to dismiss this question?
    </ConfirmationModal>
  )
}

export default React.memo(DismissQuestionModal)
